import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import NavBar from '../navbar/NavBar';
import SideNavBar from '../navbar/SideNavBar';
import DrawerHeader from '../navbar/DrawerHeader';
import { fetchMenuList } from '../../redux/slices/menuSlice';
import { useMediaQuery, Fade } from '@mui/material';

const drawerWidth = 240;

const Layout = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const isSm = useMediaQuery('(min-width:600px)');
  const [bloqueoDrawer, setBloqueoDrawer] = useState(false);

  useEffect(() => {
    dispatch(fetchMenuList());
  }, [dispatch]);

  const handleDrawerState = (state) => {
    setOpen(state);
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh', position: 'relative' }}>
      <NavBar
        drawerOpen={open}
        drawerWidth={drawerWidth}
        handleOpenDrawer={setOpen}
        handleBloqueoDrawer={() => setBloqueoDrawer((prev) => !prev)}
      />

      <Box
        sx={{
          position: isSm ? 'static' : 'absolute',
          zIndex: 2,
        }}
      >
        <SideNavBar
          open={open}
          drawerWidth={drawerWidth}
          handleDrawerState={handleDrawerState}
          isMobile={!isSm}
        />
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          bgcolor: 'background.default',
          transition: 'filter 0.3s ease',
          ...(open && !isSm
            ? {
                filter: 'brightness(0.9)',
                pointerEvents: 'none',
              }
            : {}),
        }}
      >
        <DrawerHeader />
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
